import { Link } from 'react-router-dom';
import { parseMenuConfig } from '../utils/menu';
import { useReunion } from '../contexts/ReunionContext';
import { reunion2027 } from '../data/reunion2027';

export const Footer = () => {
  const menuItems = parseMenuConfig();
  const siteName = import.meta.env.VITE_SITE_NAME || 'KG ProDesign';
  const { reunion } = useReunion();
  const reveal2027Enabled = reunion?.featureToggles?.reunion2027RevealEnabled === true;

  // Split site name for branded styling (same pattern as Header)
  const nameParts = siteName.split(' ');
  const firstWord = nameParts[0];
  const restWords = nameParts.slice(1).join(' ');

  return (
    <footer className="bg-slate-900 text-slate-300 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

          {/* Brand column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-2">
              <div className="bg-primary p-1.5 rounded-lg text-white">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <span className="text-xl font-bold tracking-tight text-white uppercase">
                {firstWord}
                {restWords && <span className="text-primary">{restWords}</span>}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-slate-400">
              The official hub for the Goldson-Wade Family Reunion. Our last major reunion was in 2018 — the next one is coming soon.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-6">Quick Links</h4>
            <ul className="space-y-4 text-sm">
              {menuItems.map(item => {
                const to = item.path.startsWith('/') ? item.path : `/${item.path}`;
                return (
                  <li key={item.path}>
                    {item.external ? (
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-primary transition-colors"
                      >
                        {item.title}
                      </a>
                    ) : (
                      <Link to={to} className="hover:text-primary transition-colors">
                        {item.title}
                      </Link>
                    )}
                  </li>
                );
              })}
              <li>
                <Link to="/register" className="hover:text-primary transition-colors">
                  Sign Up
                </Link>
              </li>
              <li>
                <Link to="/login" className="hover:text-primary transition-colors">
                  Login
                </Link>
              </li>
            </ul>
          </div>

          {/* Reunion Info */}
          <div>
            <h4 className="text-white font-bold mb-6">Next Reunion</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              {reveal2027Enabled ? (
                <li>
                  <Link to="/reunion-2027" className="text-primary-light font-semibold hover:text-primary transition-colors">
                    {reunion2027.hero.destination} · {reunion2027.hero.dateLabel}
                  </Link>
                </li>
              ) : (
                <li>Goldson-Wade Family</li>
              )}
              <li>
                <Link to="/schedule" className="hover:text-primary transition-colors">
                  View Schedule
                </Link>
              </li>
              <li>
                <Link to="/pay" className="hover:text-primary transition-colors">
                  Make a Payment
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary transition-colors">
                  Questions? Contact us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-bold mb-6">Legal</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <Link to="/terms" className="hover:text-primary transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cancellation-policy" className="hover:text-primary transition-colors">
                  Cancellation & Refund Policy
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>&copy; {new Date().getFullYear()} KG ProDesign LLC. All rights reserved.</p>
          <a
            href="https://kgprodesign.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-slate-300 transition-colors"
          >
            <span>Developed by</span>
            <img
              src="/images/KGProDesign_wht.png"
              alt="KG ProDesign"
              className="h-5 w-auto opacity-70 hover:opacity-100 transition-opacity"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};
